import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';


import DropZone from 'components/Shared/DropZone';
import LoadingButton from 'components/Shared/LoadingButton';




class AddReponse extends React.Component {


    render() {
        const { open, text, reponseAttendue, onClickAnswer, onClickCancel, onClickSave, onChange, onChangeReponseAttendue, isAdding } = this.props;

        let sauvegardable = text.length > 0;

        return (

            <React.Fragment>

                <div hidden={open || isAdding}>
                    <Button onClick={onClickAnswer} variant="outlined" >Répondre</Button>
                </div>

                {(open || isAdding) && (

                    <Card>

                        <CardContent>

                            <Stack spacing={1}>

                                <TextField
                                    name="text"
                                    label="Votre réponse"
                                    placeholder="Votre réponse"
                                    multiline
                                    margin="normal"
                                    value={text}
                                    onChange={onChange}
                                    autoFocus
                                    disabled={isAdding}
                                />

                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="reponseAttendue"
                                            name="reponseAttendue"
                                            checked={reponseAttendue}
                                            onChange={onChangeReponseAttendue}
                                            color="secondary"
                                            disabled={isAdding}
                                        />
                                    }
                                    label="Réponse attendue : "
                                    labelPlacement="start"
                                />

                                <DropZone id="fichiersIds" name="fichiersIds" onChange={onChange} />
                                
                            </Stack >
                        </CardContent>

                        <CardActions sx={{ justifyContent: 'right' }}>
                            <Button
                                onClick={onClickCancel}
                                color="primary"
                                disabled={isAdding}
                            >
                                Annuler
                            </Button>
                            <LoadingButton
                                disabled={!sauvegardable || isAdding}
                                onClick={onClickSave}
                                label="Enregistrer"
                                pending={isAdding}
                            />
                        </CardActions>

                    </Card>                    
                )}


            </React.Fragment>
        );
    }
}
AddReponse.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickSave: PropTypes.func.isRequired,
    onClickAnswer: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeReponseAttendue: PropTypes.func.isRequired, 
    text: PropTypes.string.isRequired,
    reponseAttendue: PropTypes.bool.isRequired,
    isAdding: PropTypes.bool.isRequired
};

export default AddReponse;